import useEnabledFeature from '../../useEnabledFeature';

const useComposedGrid = (): boolean => {
  return useEnabledFeature('cat-composed-grid');
};

export default useComposedGrid;
